import React from 'react';
import { formatText } from './TemplateUtils';

const BodyText = ({ text = '', sampleValues = {} }) => {
  if (!text || typeof text !== 'string') {
    return <span className="text-gray-500 dark:text-gray-300 italic">Body text will appear here...</span>;
  }
  const formattedText = formatText(text, sampleValues);
  const parts = formattedText.split(/(\{\{\d+\}\})/g);
  return parts.map((part, i) => {
    if (part.match(/\{\{\d+\}\}/)) {
      return (
        <span
          key={i}
          className="bg-blue-100 dark:bg-blue-900/40 text-blue-600 dark:text-blue-300 px-1 rounded mx-0.5 font-medium text-xs"
        >
          {part}
        </span>
      );
    }
    return part;
  });
};

export default BodyText;
